import React from 'react'
import BuyerProfile from './Role/BuyerProfile'
import SellerFields from './Role/SellerFields'

const UserFieldsView = (props) => {
    return props.seller ? (
        <SellerFields
            data={props.data}
            fieldValue={props.fieldValue}
            function={props.function}
            customInitial={props.customInitial}
            customValidation={props.customValidation}
            additionalFormikUpdate={props.additionalFormikUpdate}
        />
    ) : (
        <BuyerProfile
            data={props.data}
            fieldValue={props.fieldValue}
            function={props.function}
            customInitial={props.customInitial}
            customValidation={props.customValidation}
            additionalFormikUpdate={props.additionalFormikUpdate}
            invoiceTab={props.invoiceTab}
            lisingonly={props.lisingonly}
        />
    )
}

export default UserFieldsView
